import {
    FETCH_HEALTH_SNAPSHOT_LIST_START,
    FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_LIST_FAIL,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL
} from 'actions/ActionTypes';

import { listOptions } from 'utils/healthSnapshot/healthSnapshotConstants';

const INITIAL_STATE = {
    healthSnapshotList: null,
    healthSnapshotListFetching: false,
    healthSnapshotListSuccess: false,
    healthSnapshotListFail: false,
    healthSnapshotListByDateRange: null,
    healthSnapshotListByDateRangeFetching: false,
    healthSnapshotListByDateRangeSuccess: false,
    healthSnapshotListByDateRangeFail: false,
    healthSnapshotListItemDeleting: false,
    healthSnapshotListItemDeleteSuccess: false,
    healthSnapshotListItemDeleteFail: false,
    healthSnapshotListItemUpdating: false,
    healthSnapshotListItemUpdateSuccess: false,
    healthSnapshotListItemUpdateFail: false
};

const healthSnapshotListFetching = (state) => ({
    ...state,
    healthSnapshotListFetching: true
});

const healthSnapshotListFetchFinished = (isSuccess) => (state, action) => {
    let updatedList;

    if (
        state.healthSnapshotList &&
        state.healthSnapshotList.length > 0 &&
        action.startIndex > listOptions.initialStartIndex
    ) {
        updatedList = isSuccess ? state.healthSnapshotList.concat(action.data) : state.healthSnapshotList;
    } else {
        updatedList = isSuccess ? action.data : null;
    }

    return {
        ...state,
        healthSnapshotList: updatedList,
        healthSnapshotListFetching: false,
        healthSnapshotListSuccess: isSuccess,
        healthSnapshotListFail: !isSuccess
    };
};

const healthSnapshotListByDateRangeFetching = (state) => {
    return {
        ...state,
        healthSnapshotListByDateRangeFetching: true
    };
};

const healthSnapshotListByDateRangeFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        healthSnapshotListByDateRange: action.data,
        healthSnapshotListByDateRangeFetching: false,
        healthSnapshotListByDateRangeSuccess: isSuccess,
        healthSnapshotListByDateRangeFail: !isSuccess
    };
};

const healthSnapshotListItemDeleting = (state) => {
    if (!state.healthSnapshotList) {
        return state;
    }

    return {
        ...state,
        healthSnapshotListItemDeleting: true
    };
};

const healthSnapshotListItemDeleteFinished = (isSuccess) => (state, action) => {
    if (!state.healthSnapshotList) {
        return state;
    }

    const activityUuid = action.payload;
    const newHealthSnapshotList = state.healthSnapshotList.filter(
        (listItem) => listItem.activityUuid.uuid !== activityUuid
    );
    return {
        ...state,
        healthSnapshotList: newHealthSnapshotList,
        healthSnapshotListItemDeleting: false,
        healthSnapshotListItemDeleteSuccess: isSuccess,
        healthSnapshotListItemDeleteFail: !isSuccess
    };
};

const healthSnapshotListItemUpdating = (state) => {
    if (!state.healthSnapshotList) {
        return state;
    }

    return {
        ...state,
        healthSnapshotListItemUpdating: true
    };
};

const healthSnapshotListItemUpdateFinished = (isSuccess) => (state, action) => {
    if (!state.healthSnapshotList) {
        return state;
    }

    const { activityName, activityUuid } = action.payload;
    const newHealthSnapshotList = state.healthSnapshotList.map((listItem) => {
        if (listItem.activityUuid.uuid === activityUuid) {
            listItem.activityName = activityName;
        }
        return listItem;
    });
    return {
        ...state,
        healthSnapshotList: newHealthSnapshotList,
        healthSnapshotListItemUpdating: false,
        healthSnapshotListItemUpdateSuccess: isSuccess,
        healthSnapshotListItemUpdateFail: !isSuccess
    };
};

export const isHealthSnapshotListFetching = (state) => state.healthSnapshotList.healthSnapshotListFetching;

export const isHealthSnapshotListSuccess = (state) => state.healthSnapshotList.healthSnapshotListSuccess;

export const isHealthSnapshotListFail = (state) => state.healthSnapshotList.healthSnapshotListFail;

export const getHealthSnapshotList = (state) => state.healthSnapshotList.healthSnapshotList;

export const isHealthSnapshotListByDateRangeFetching = (state) =>
    state.healthSnapshotList.healthSnapshotListByDateRangeFetching;

export const isHealthSnapshotListByDateRangeSuccess = (state) =>
    state.healthSnapshotList.healthSnapshotListByDateRangeSuccess;

export const isHealthSnapshotListByDateRangeFail = (state) =>
    state.healthSnapshotList.healthSnapshotListByDateRangeFail;

export const getHealthSnapshotListByDateRange = (state) => state.healthSnapshotList.healthSnapshotListByDateRange;

export const isHealthSnapshotListItemDeleting = (state) => state.healthSnapshotList.healthSnapshotListItemDeleting;

export const isHealthSnapshotListItemDeleteSuccess = (state) =>
    state.healthSnapshotList.healthSnapshotListItemDeleteSuccess;

export const isHealthSnapshotListItemDeleteFail = (state) =>
    state.healthSnapshotList.isHealthSnapshotListItemDeleteFail;

export const isHealthSnapshotListItemUpdating = (state) => state.healthSnapshotList.healthSnapshotListItemUpdating;

export const isHealthSnapshotListItemUpdateSuccess = (state) =>
    state.healthSnapshotList.healthSnapshotListItemUpdateSuccess;

export const isHealthSnapshotListItemUpdateFail = (state) => state.healthSnapshotList.healthSnapshotListItemUpdateFail;

const handlers = {
    [FETCH_HEALTH_SNAPSHOT_LIST_START]: healthSnapshotListFetching,
    [FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS]: healthSnapshotListFetchFinished(true),
    [FETCH_HEALTH_SNAPSHOT_LIST_FAIL]: healthSnapshotListFetchFinished(false),

    [FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START]: healthSnapshotListByDateRangeFetching,
    [FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS]: healthSnapshotListByDateRangeFetchFinished(true),
    [FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL]: healthSnapshotListByDateRangeFetchFinished(false),

    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START]: healthSnapshotListItemDeleting,
    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS]: healthSnapshotListItemDeleteFinished(true),
    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL]: healthSnapshotListItemDeleteFinished(false),

    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START]: healthSnapshotListItemUpdating,
    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS]: healthSnapshotListItemUpdateFinished(true),
    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL]: healthSnapshotListItemUpdateFinished(false)
};

export default function healthSnapshotList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
